import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFullProtect = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 10 10",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M5 9.156q-1.458-.365-2.396-1.692a4.94 4.94 0 0 1-.937-2.912V2.073L5 .823l3.333 1.25v2.48a4.94 4.94 0 0 1-.937 2.91Q6.458 8.793 5 9.157" })
});
export default SvgFullProtect;
